module.exports = "<div class=\"error\">\n    <div class=\"head\">\n        <p>{{'home-evidences-text063' | translate}}</p>\n        <p>{{'home-evidences-text064' | translate}}{{ $ctrl.errorMessage }}</p>\n    </div>\n    <div class=\"foot\">\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.$state.go('app.page.verify.main.tsa.form')\">{{'home-evidences-text065' | translate}}</button>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/verify/signature-verify/signature-error.html
// module id = 1025
// module chunks = 3